import { storage } from '../firebase'
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage'
import { v4 as uuidv4 } from 'uuid'

export const uploadProductLogo = async (file: File, onProgress?: (progress: number) => void): Promise<string> => {
  try {
    // Generate a unique filename
    const storedFileName = `${uuidv4()}.${file.name.split('.').pop()}`
    const storageRef = ref(storage, `products/logos/${storedFileName}`)

    // Upload the file
    const uploadTask = uploadBytesResumable(storageRef, file)

    // Return a promise that resolves with the download URL
    return new Promise((resolve, reject) => {
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          // Calculate progress
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          // Call the progress callback if provided
          if (onProgress) {
            onProgress(progress)
          }
        },
        (error) => {
          console.error('Error uploading product logo:', error)
          reject(error)
        },
        async () => {
          try {
            // Get the download URL using Firebase's getDownloadURL
            const downloadURL = await getDownloadURL(storageRef)
            resolve(downloadURL)
          } catch (error) {
            console.error('Error getting download URL:', error)
            reject(error)
          }
        }
      )
    })
  } catch (error) {
    console.error('Error in uploadProductLogo:', error)
    throw error
  }
}
